<template>
	<div>
		<div class="d-content">
			<div class="mask"></div>
			<div class="mask-content">
				<el-row type="flex" justify="space-around" :gutter="24" class="m-title">
					{{newsInfo.title}}
				</el-row>
				<el-row type="flex" class="row-bg" justify="space-around">
					时间：{{newsInfo.create_time}}&nbsp;&nbsp;&nbsp;&nbsp;
					来源 ：{{newsInfo.source}}
					<!-- 访问量 ：{{newsInfo.visits}} -->
				<!--  <el-col :span="4"><div class="grid-content bg-purple">时间{{newsInfo.create_time}}</div></el-col>
				  <el-col :span="4"><div class="grid-content bg-purple-light">来源 ：{{newsInfo.source}}</div></el-col>
				  <el-col :span="4"><div class="grid-content bg-purple">访问量 ： {{newsInfo.visits}}</div></el-col> -->
				</el-row>
				<div  v-html="newsInfo.content"></div>
				<!-- <div>时间{{newsInfo.create_time}}</div>
				来源 ：source    访问量  visits    -->
			</div>
			<div class="close-button" @click="closeDetail()"><i class="el-icon-circle-close"></i></div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'InformationSecond',
		props: {
			newsInfo: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				activeIndex: 0,
				baseUrl: 'https://www.kingstronbio.com',
			}
		},
		computed: {
			visiblePrev() {
				return this.list.length > 1
			},
			visibleNext() {
				return this.list.length > 1
			}
		},
		methods: {
			changePage(type) {
				this.activeIndex = type === 'prev' ? this.activeIndex - 1 : this.activeIndex + 1;
			},
			closeModal() {
				this.$parent.hideModal();
			},
			backPrevMenu() { //返回上级目录
				this.$parent.closePage();
			},
			setActiveItem(index) {
				this.$refs.carousel.setActiveItem(index);
			},
			closeDetail(){
				this.$store.commit("setIsListening", true);
				this.$parent.showDetailPage = false;
			},
			parseImg(img) {
				return this.baseUrl + img;
			}
		},
		mounted() {
			// console.log(this.newsInfo)
		}
	}
</script>

<style lang="less" scoped>
	// @import '~bootstrap/dist/css/bootstrap.css';
	@import '../assets/css/index';
	@import '../assets/css/style';

	.d-content {
		// .scale(1681, 981);
		.pos-a(0, 0, 10);
		width:100%;
		height: 100%;

		.mask {
			.pos-a(0, 0, 4);
			width: 100%;
			height: 100%;
			background-color: #e5e3e1;
		}

		.con-item {
			border-bottom: 1px solid #e5e3e1;
		}

		.m-title {
			font-size: 30/@r;
			margin: 20/@r auto;
			font-weight: bold;
			cursor: pointer;
		}

		.m-avator {
			.scale(250, 129);
		}

		.mask-content {
			.pos-a-center();
			width: 70%;
			height: 100%;
			z-index: 5;
			background: #fff;
			padding: 0 50/@r;
			overflow-y: auto;
			font-size: 18/@r;
			overflow-x: hidden;
			/* 整个滚动条 */
			video{
				width: 100% !important;
			}
		}
		.mask-content::-webkit-scrollbar {
		    /* 对应纵向滚动条的宽度 */
		    width: 10/@r;
		    /* 对应横向滚动条的宽度 */
		    height: 20/@r;
		}
		
		/* 滚动条上的滚动滑块 */
		.mask-content::-webkit-scrollbar-thumb {
		    background-color: #49b1f5;
		    border-radius: 32px;
		}
		
		/* 滚动条轨道 */
		.mask-content::-webkit-scrollbar-track {
		    background-color: #dbeffd;
		    border-radius: 32px;
		}
		

		.close-button {
			position: absolute;
			top: 20/@r;
			right: 42/@r;
			font-size: 58/@r;
			cursor: pointer;
			transition: color 0.3s;
			// .scale(38, 38);
			z-index: 6;
			// text-align: center;
			// line-height: 38/@r;
		
			// &:hover {
			// 	color: #d9534f;
			// }
		}
	}

	.el-row {
		margin: 20/@r auto;
	}
</style>
